import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { ErrorMessage } from 'src/components/ErrorMessage';

const useStyles = makeStyles()(() => ({
  root: {
    minHeight: 1,
    marginBottom: 20,
  },
}));

/**
 * This component is used to wrap the error callout
 * with a fixed height to avoid the form jumping.
 * @returns {JSX.Element} Returns the error callout
 */
export const OnboardingFormError: React.FC<{
  errorText: string;
}> = ({ errorText }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      {errorText && <ErrorMessage message={errorText} />}
    </div>
  );
};
